import React, { useState, useEffect } from "react";
import { FaComments, FaTimes } from "react-icons/fa";
import stsData from "./stsData"; // import category data

export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [stage, setStage] = useState("category"); // "category" | "question"
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [questionPage, setQuestionPage] = useState(0); // for pagination

  useEffect(() => {
    if (open && messages.length === 0) {
      setMessages([
        { text: "👋 Hi! Welcome to STS Institute!", sender: "bot" },
        { text: "Please choose a category to start 👇", sender: "bot" },
      ]);
    }
  }, [open]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setStage("question");
    setQuestionPage(0);
    setMessages((prev) => [
      ...prev,
      { text: category.name, sender: "user" },
      { text: `Here are some common questions about ${category.name}:`, sender: "bot" },
    ]);
  };

  const handleQuestionClick = (qa) => {
    const userMessage = { text: qa.question, sender: "user" };
    const botMessage = { text: qa.answer, sender: "bot" };
    setMessages((prev) => [...prev, userMessage, botMessage]);

    // after answering, show same category options again
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { text: "Would you like to ask another question from this category? 👇", sender: "bot" },
      ]);
    }, 500);
  };

  const handleOtherClick = () => {
    setQuestionPage((prev) => prev + 1);
  };

  const handleBackToCategories = () => {
    setStage("category");
    setSelectedCategory(null);
    setMessages((prev) => [
      ...prev,
      { text: "🔙 Back to main categories", sender: "user" },
      { text: "Please choose a category again 👇", sender: "bot" },
    ]);
  };

  const getCurrentQuestions = () => {
    if (!selectedCategory) return [];
    const start = questionPage * 4;
    return selectedCategory.questions.slice(start, start + 4);
  };

  return (
    <div>
      {/* Floating Button */}
      <div className="chatbot-button" onClick={() => setOpen(!open)}>
        {open ? <FaTimes size={22} /> : <FaComments size={22} />}
      </div>

      {/* Chat Window */}
      {open && (
        <div className="chatbot-window">
          <div className="chatbot-header">💬 STS Assistant</div>

          <div className="chatbot-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`chatbot-message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}

            {/* Options Section */}
            <div className="chatbot-options">
              {stage === "category" &&
                stsData.map((cat, i) => (
                  <button
                    key={i}
                    className="chatbot-option"
                    onClick={() => handleCategoryClick(cat)}
                  >
                    {cat.name}
                  </button>
                ))}

              {stage === "question" &&
                getCurrentQuestions().map((qa, i) => (
                  <button
                    key={i}
                    className="chatbot-option"
                    onClick={() => handleQuestionClick(qa)}
                  >
                    {qa.question}
                  </button>
                ))}

              {/* Other button */}
              {stage === "question" &&
                selectedCategory &&
                (questionPage + 1) * 4 < selectedCategory.questions.length && (
                  <button className="chatbot-option" onClick={handleOtherClick}>
                    Other Questions 🔄
                  </button>
                )}

              {/* Back to categories button */}
              {stage === "question" && (
                <button
                  className="chatbot-option back-btn"
                  onClick={handleBackToCategories}
                >
                  🔙 Back to Categories
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
